import { render, staticRenderFns } from "./pcTitle.vue?vue&type=template&id=449bacad&"
import script from "./pcTitle.vue?vue&type=script&lang=js&"
export * from "./pcTitle.vue?vue&type=script&lang=js&"
import style0 from "./pcTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports